import { Grid, IconButton } from "@material-ui/core";
import IconDelete from "app/common/Icon/IconDelete";
import { LEAD_SOURCE_LEVEL, VOUCHER_INVOICE_TYPE } from "app/common/LocalConst";
import { formatMoney, getDateTime } from "app/common/LocalFunction";
import { getListCode } from "app/services/CustomerSourceService";
import { FieldArray, getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { memo } from "react";
function OrderDepositDeductionTable() {
    const { values, setFieldValue } = useFormikContext();

    const handleGetListCodeSource = async (obj) => {
        try {
            const { data } = await getListCode(obj);
            setFieldValue("listCodeSource", data || []);
        } catch (error) {
            // handle error nếu cần
        }
    };
    // patient ko đổi nên lấy từ old được
    const patientId =
        values?.patient?.id ||
        values?.oldTreatmentPlanCard?.patient?.id ||
        values?.oldPatientServiceRegister?.patient?.id ||
        values?.oldProduct?.patient?.id;
    
    // thông tin khác thì phải lấy từ form hiện tại
    const invoiceItemAllocations =
        values?.invoiceItemAllocations ||
        values?.newTreatmentPlanCard?.invoiceItemAllocations ||
        values?.newPatientServiceRegister?.invoiceItemAllocations ||
        values?.newProduct?.invoiceItemAllocations || [];
    const voucherAllocations =
        values?.voucherAllocations ||
        values?.newTreatmentPlanCard?.voucherAllocations ||
        values?.newPatientServiceRegister?.voucherAllocations ||
        values?.newProduct?.voucherAllocations || [];
    const startDate =
        values?.startDate ||
        values?.orderDate ||
        values?.newTreatmentPlanCard?.startDate ||
        values?.newTreatmentPlanCard?.orderDate ||
        values?.newPatientServiceRegister?.startDate ||
        values?.newPatientServiceRegister?.orderDate ||
        values?.newProduct?.startDate ||
        values?.newProduct?.orderDate;
    const departmentId =
        values?.department?.id ||
        values?.newTreatmentPlanCard?.department?.id ||
        values?.newPatientServiceRegister?.department?.id ||
        values?.newProduct?.department?.id;

    const handleRemove = (removeIndex) => {
        const remainInvoiceItems = Array.isArray(invoiceItemAllocations)
            ? invoiceItemAllocations.filter((_, index) => index !== removeIndex)
            : [];

        const searchCodeSource = {
            level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
            startDate: startDate,
            patientId: patientId,
            departmentId: departmentId,

            voucherIds: Array.isArray(voucherAllocations)
                ? voucherAllocations
                    .map(item => item?.voucher?.id)
                    .filter(Boolean)
                : [],

            // 👉 chỉ lấy invoiceItem còn lại
            invoiceItemIds: remainInvoiceItems
                .map(item => item?.invoiceItem?.id)
                .filter(Boolean),
        };

        handleGetListCodeSource(searchCodeSource);
    };

    return (
        <FieldArray name="invoiceItemAllocations">
            {({ remove, push }) => (
                <>
                    <Grid item xs={12}>
                        <div className="table-root mt-2">
                            <div style={{ minWidth: "760px" }}>
                                <table className="table-container">
                                    <thead>
                                        <tr className="row-table-header">
                                            <th width="5%">STT</th>
                                            <th width="15%">Ngày lên đơn hàng</th>
                                            <th width="10%">Mã đơn hàng</th>
                                            <th width="20%">Tên đơn hàng</th>
                                            <th width="10%">Cơ sở</th>
                                            <th width="8%" align="center">
                                                Thao tác
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {values?.invoiceItemAllocations?.length > 0 ? (
                                            values.invoiceItemAllocations.map((item, i) => (
                                                <tr key={i}>
                                                    <td align="center">{i + 1}</td>
                                                    <td align="center">
                                                        {getDateTime(item?.invoiceItem?.invoiceDate)}
                                                    </td>
                                                    <td>
                                                        {item?.invoiceItem?.patientServiceRegister?.code || item?.invoiceItem?.treatmentPlanCard?.code || item?.invoiceItem?.drugOrder?.code}
                                                    </td>
                                                    <td align="left">
                                                        {item?.invoiceItem?.invoiceItemName || item?.invoiceItem?.patientServiceRegister?.name || item?.invoiceItem?.treatmentPlanCard?.name || item?.invoiceItem?.drugOrder?.name}
                                                    </td>
                                                    <td align="center">
                                                        {item?.invoiceItem?.department?.name}
                                                    </td>
                                                    <td align="center">
                                                        <IconButton
                                                            size="small"
                                                            color="secondary"
                                                            onClick={() => {
                                                                remove(i);
                                                                handleRemove(i);
                                                            }}
                                                        >
                                                            <IconDelete />
                                                        </IconButton>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={4} align="center" style={{ fontStyle: "italic" }}>
                                                    Không có dữ liệu
                                                </td>
                                            </tr>
                                        )}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Grid>
                </>
            )}
        </FieldArray>
    );
}

export default memo(observer(OrderDepositDeductionTable));
